/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BiomarkersDashboardResponse
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Get all biomarker results with categories and summary

Returns complete biomarker dashboard including:
- Summary with counts across all classifications
- Categories with their biomarkers and individual results
- Classifications:
  - Optimal: Best possible range
  - Normal: Within healthy range but not optimal
  - Out of Range: Outside normal parameters
  - Critical: Requires immediate medical attention
  - No Results: Not yet tested

Returns:
    BiomarkersDashboardResponse with summary and categorized results
 * @summary Get Biomarkers
 */
export const getBiomarkersV1BiomarkersGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<BiomarkersDashboardResponse>(
      {url: `/v1/biomarkers`, method: 'GET', signal
    },
      );
    }
  



export const getGetBiomarkersV1BiomarkersGetQueryKey = () => {
    return [
    `/v1/biomarkers`
    ] as const;
    }

    
export const getGetBiomarkersV1BiomarkersGetQueryOptions = <TData = Awaited<ReturnType<typeof getBiomarkersV1BiomarkersGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBiomarkersV1BiomarkersGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBiomarkersV1BiomarkersGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBiomarkersV1BiomarkersGet>>> = ({ signal }) => getBiomarkersV1BiomarkersGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBiomarkersV1BiomarkersGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBiomarkersV1BiomarkersGetQueryResult = NonNullable<Awaited<ReturnType<typeof getBiomarkersV1BiomarkersGet>>>
export type GetBiomarkersV1BiomarkersGetQueryError = unknown


export function useGetBiomarkersV1BiomarkersGet<TData = Awaited<ReturnType<typeof getBiomarkersV1BiomarkersGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBiomarkersV1BiomarkersGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBiomarkersV1BiomarkersGet>>,
          TError,
          Awaited<ReturnType<typeof getBiomarkersV1BiomarkersGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBiomarkersV1BiomarkersGet<TData = Awaited<ReturnType<typeof getBiomarkersV1BiomarkersGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBiomarkersV1BiomarkersGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBiomarkersV1BiomarkersGet>>,
          TError,
          Awaited<ReturnType<typeof getBiomarkersV1BiomarkersGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBiomarkersV1BiomarkersGet<TData = Awaited<ReturnType<typeof getBiomarkersV1BiomarkersGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBiomarkersV1BiomarkersGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Biomarkers
 */

export function useGetBiomarkersV1BiomarkersGet<TData = Awaited<ReturnType<typeof getBiomarkersV1BiomarkersGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBiomarkersV1BiomarkersGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBiomarkersV1BiomarkersGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




